import React, { Component } from 'react';
import parse from 'date-fns/parse';
import range from 'lodash/range';
import cx from 'classnames';
import { Trans } from '@lingui/macro';

import Plotly from '../utils/plotly.bundle';
import { weekdayTranslate } from '../utils';
import styles from './SystemDailyHourDeal.module.scss';

const graphDiv = 'system-daily-hour-deal';
const weekdayColor = 'rgb(164, 194, 244)';
const weekendColor = 'rgb(234, 153, 153)';

export default class SystemDailyHourDeal extends Component {
    constructor(props) {
        super(props);

        this.height = props.isMobile ? 200 : 300;
        this.state = {
            hideWeekday: false,
            hideWeekend: false,
            weekdayTraces: [],
            weekendTraces: [],
        };
    }

    componentDidMount() {
        this.prepareTraceData(this.drawChart);
    }

    prepareTraceData = (cb) => {
        const weekdayTraces = [];
        const weekendTraces = [];
        const { data } = this.props;

        Object.keys(data).forEach((date) => {
            const day = parse(date, 'yyyy/M/d', new Date());
            const week = day.getDay();
            const isWeekend = week === 0 || week === 6;
            const trace = this._genDatasets(date, data[date], day, isWeekend);
            if (isWeekend) weekendTraces.push(trace);
            else weekdayTraces.push(trace);
        });

        this.setState({ weekdayTraces, weekendTraces }, () => cb());
    }

    drawChart = () => {
        const { isMobile } = this.props;
        const { weekdayTraces, weekendTraces } = this.state;
        const data = [...weekdayTraces, ...weekendTraces];
        const layout = {
            showlegend: !isMobile, // dont show legend at mobile
            legend: {
                orientation: 'h',
            },
            margin: {
                l: 30,
                r: 30,
            },
            traceorder: 'reversed',
            xaxis: {
                type: 'category',
            },
            hovermode: 'closest',
        };

        Plotly.newPlot(graphDiv, data, layout, { displayModeBar: false });
    }

    toggleWeekday = () => {
        const { weekdayTraces, hideWeekday } = this.state;
        const nextHideWeekday = !hideWeekday;
        this.setState({ hideWeekday: nextHideWeekday }, () => {
            if (nextHideWeekday) Plotly.deleteTraces(graphDiv, range(weekdayTraces.length));
            else Plotly.addTraces(graphDiv, weekdayTraces, range(weekdayTraces.length));
        });
    }

    toggleWeekend = () => {
        const { weekendTraces, hideWeekend } = this.state;
        const nextHideWeekend = !hideWeekend;
        this.setState({ hideWeekend: nextHideWeekend }, () => {
            if (nextHideWeekend) Plotly.deleteTraces(graphDiv, range(-1, -(weekendTraces.length + 1)));
            else Plotly.addTraces(graphDiv, weekendTraces);
        });
    }

    _genDatasets = (name, data, day, isWeekend) => {
        const weekday = {
            line: {
                color: weekdayColor,
                width: 1,
            },
        };

        const weekend = {
            line: {
                color: weekendColor,
                width: 1,
            },
        };
        const hours = [...Array(24).keys()];
        const y = hours.map(hour => data[hour] || 0);
        const basicConfig = {
            hoverinfo: 'text',
            x: hours,
            y,
            text: this._getText(day, y),
            type: 'lines',
            name,
        };
        const color = isWeekend ? weekend : weekday;
        return {
            ...basicConfig,
            ...color,
        };
    }

    _getText = (day, value) => {
        const { locale } = this.props;
        const date = `${day.getFullYear()}-${day.getMonth() + 1}-${day.getDate()}`;
        const prefix = `${date} (${weekdayTranslate(locale, day.getDay(), true)})`;
        return value.map(v => `${prefix}: ${v}`);
    }

    render() {
        const { hideWeekday, hideWeekend } = this.state;

        return (
            <div className="mb-3">
                <h3 className="system-head">
                    <Trans id="system.tripDurationWday" />
                </h3>
                <div
                    tabIndex={0}
                    role="button"
                    className={cx(styles.hourLegend, { [styles.active]: !hideWeekday })}
                    onKeyDown={this.toggleWeekday}
                    onClick={this.toggleWeekday}
                >
                    <div
                        className={styles.square}
                        style={{ backgroundColor: weekdayColor }}
                    />
                    <span><Trans id="common.weekday" /></span>
                </div>
                <div
                    tabIndex={0}
                    role="button"
                    className={cx(styles.hourLegend, { [styles.active]: !hideWeekend })}
                    onKeyDown={this.toggleWeekend}
                    onClick={this.toggleWeekend}
                >
                    <div
                        className={styles.square}
                        style={{ backgroundColor: weekendColor }}
                    />
                    <span><Trans id="common.weekend" /></span>
                </div>
                <div id="system-daily-hour-deal" />
            </div>
        );
    }
}
